// extracted by mini-css-extract-plugin
export var container = "_rv-0";
export var table = "_rv-2";
export var tableWrapper = "_rv-1";